// extracted by mini-css-extract-plugin
export var dropdown = "_ja-0";
export var imagePlaceholder = "_ja-2";
export var imageWrapper = "_ja-3";
export var productImage = "_ja-1";
export var truncateContainer = "_ja-4";
export var truncateText = "_ja-5";